import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { ActivitySummaryDto } from './activity-summary.dto'
import { UserSummary } from '@sphere/user/domain'

export class UserAssignmentResponseDto {
  @ApiProperty({ type: 'string' })
  id!: string
  @ApiProperty({ type: 'string' })
  activityId!: string
  @ApiProperty({ type: 'string' })
  userId!: string
  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  availableFrom!: Date | string | null
  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  dueAt!: Date | string | null
  @ApiPropertyOptional({ type: Number, nullable: true })
  maxAttempts!: number | null
  @ApiProperty({ type: Boolean })
  showSolutions!: boolean
  @ApiProperty({ type: 'string', format: 'date-time' })
  createdAt!: Date
  @ApiProperty({ type: 'string', format: 'date-time' })
  updatedAt!: Date

  @ApiPropertyOptional({ type: () => ActivitySummaryDto })
  activity?: ActivitySummaryDto
  @ApiPropertyOptional({
    description: 'Capabilities calculés',
    type: 'object',
    additionalProperties: true,
  })
  capabilities?: Record<string, boolean>
  @ApiPropertyOptional({
    description: 'Résumé utilisateur',
    type: 'object',
    properties: {
      id: { type: 'string' },
      displayName: { type: 'string', nullable: true },
      email: { type: 'string', nullable: true },
      avatarUrl: { type: 'string', nullable: true },
    },
  })
  user?: UserSummary
}
